import React, {useState} from "react";
import PeopleCard from './peopleCard.js';

const SearchPeople = () => {

    const [queryPerson, setQueryPerson] = useState('');
    const [people, setPeople] = useState([]);

    const TMDB_KEY = process.env.REACT_APP_TMDB_KEY || "";
    
    const searchTV = async (e) => {
        e.preventDefault();
    
        const url = `https://api.themoviedb.org/3/search/person?api_key=${TMDB_KEY}&language=en-US&query=${queryPerson}&page=1&include_adult=false`;
        
        try {
            const res = await fetch(url)
            const data  = await res.json()
            setPeople(data.results)
        } catch(err) {
            console.error(err);
        }

    }    
    return (
        <>
            <form className="form" onSubmit={searchTV}>
                <label className="label" htmlFor="querytv">Cast Member/Crew Member</label>
                <div className="input-wrapper">
                    <input className="input" type="text" name="querytv"  required
                        placeholder="i.e. Steven Spielberg"
                        value={queryPerson} onChange={(e) => setQueryPerson(e.target.value)}
                    />
                    {queryPerson.length > 0 && <button type="button" className="clear-button" aria-label="Clear" onClick={() => setQueryPerson('')}><i className="ri-close-line" /></button>}
                </div>
                <button className="button" type="submit">Search</button>
            </form>
            <hr />
            <div className="card-list">
                {people.map(person => (
                    <PeopleCard person={person} key={person.id} />
                ))}
            </div>    
        </>
    )
}


export default SearchPeople